import Vue from 'vue'
import formatter from '@/utils/formatter'

Vue.filter('cpf', formatter.formatCPF)
Vue.filter('preco', v => {
 const options = { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }
 const formatNumber = new Intl.NumberFormat('pt-BR', options)
 return formatNumber.format(v)
})
